import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';

@Component({
  selector: 'app-coaching-confirmation-modal',
  templateUrl: './coaching-confirmation-modal.component.html',
  styleUrls: ['./coaching-confirmation-modal.component.scss'],
})
export class CoachingConfirmationModalComponent implements OnInit {
  public selectedOption: string;

  constructor(
    public dialogRef: MatDialogRef<CoachingConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    public dataService: DataService,
    public accessService: AccessService,
    private mixpanelService: MixPanelService
  ) {}

  ngOnInit(): void {
    this.selectedOption = this.data.enableSelfCoaching ? 'self' : 'inPerson';
    this.mixpanelService.track('modal-opened/configurations-page/coaching-page/switch-coaching-mode-confirmation/open');

    this.dialogRef.backdropClick().subscribe(() => {
      this.mixpanelService.track('modal-closed/configurations-page/coaching-page/switch-coaching-mode-confirmation/tap-outside');
    });
  }

  saveSelection() {
    this.mixpanelService.track('button-clicked/configurations-page/coaching-page/switch-coaching-mode-confirmation/confirm-switch', {
      SwitchedTo: !this.data.enableSelfCoaching ? 'self' : 'inPerson',
    });

    this.dialogRef.close(!this.data.enableSelfCoaching);
  }

  cancelSelection() {
    this.mixpanelService.track('button-clicked/configurations-page/coaching-page/switch-coaching-mode-confirmation/cancel');
    this.dialogRef.close(this.data.enableSelfCoaching);
  }

  closeIconClick() {
    this.mixpanelService.track('modal-closed/configurations-page/coaching-page/switch-coaching-mode-confirmation/close-icon');
    this.dialogRef.close(this.data.enableSelfCoaching);
  }
}
